// 趣味診断 Vue3 アプリケーション
import { createApp } from 'vue'
import ShindanApp from '../components/ShindanApp.vue'

// マウント対象が存在する場合のみ初期化
document.addEventListener('DOMContentLoaded', () => {
  const mountEl = document.getElementById('shindan-app')
  if (!mountEl) return

  // データ属性からpropsを取得
  const questions = JSON.parse(mountEl.dataset.questions || '[]')
  const generations = JSON.parse(mountEl.dataset.generations || '[]')
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  const device = mountEl.dataset.device || 'pc'
  const previousResult = mountEl.dataset.previousResult ? JSON.parse(mountEl.dataset.previousResult) : null

  const app = createApp(ShindanApp, {
    questions,
    generations,
    csrfToken,
    device,
    previousResult
  })

  app.mount(mountEl)
})
